
import React from "react";
import { Switch,Redirect, Route } from "react-router-dom";
import Main from "./../layout/Main";
function AuthRoute({ component: Component, ...restOfProps }) {
  const isAuthenticated = localStorage.getItem("isAuthenticated");
  console.log("this", isAuthenticated);

  return (
    <div className="App">
    <Switch>
   
    <Route
      {...restOfProps}
      render={(props) =>
        isAuthenticated ?  <Main><Component {...props} /> </Main> : <Redirect to="/sign-in" />
      }
    />
   
    </Switch>
    </div>
  );
}

export default AuthRoute;